import apiService from '@/services/apiService';

const actions = {
  getMasterProviderWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/provider/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMasterProviders({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('ppob/provider')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMasterProvider({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`ppob/provider/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/provider/${payload.id}/update-status`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postMasterProvider({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/provider', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putMasterProvider({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`ppob/provider/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;